module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_pt15.6a6d3f46.png";